import { motion } from "framer-motion";
import { Check, Sparkles, ArrowUpRight } from "lucide-react";
import { OFFER, ICLOSED_URL } from "../data/content";
import { Reveal, Overline } from "./Reveal";

export default function Pricing() {
  return (
    <section id="offre" data-testid="pricing-section" className="relative px-6 py-24 lg:py-32">
      <div className="pointer-events-none absolute left-1/2 top-1/3 -z-10 h-[360px] w-[560px] -translate-x-1/2 rounded-full bg-[#2563EB] opacity-[0.14] blur-[160px]" aria-hidden="true" />

      <Reveal className="mb-14 text-center">
        <Overline>Notre offre</Overline>
        <h2 className="font-head mx-auto mt-4 max-w-3xl text-4xl font-extrabold text-[#0B1220] sm:text-5xl">
          Une formule pour <span className="text-[#3B82F6]">exploser vos performances</span>.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-[#5B6B85]">{OFFER.desc}</p>
      </Reveal>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto mt-6 max-w-3xl"
      >
        <span className="btn-blue absolute -top-4 left-1/2 z-10 inline-flex -translate-x-1/2 items-center gap-2 rounded-full px-5 py-2 text-xs font-bold uppercase tracking-wider text-[#0B1220]">
          <Sparkles size={14} /> {OFFER.name}
        </span>

        <div className="card-dark rounded-[2rem] p-8 pt-12 lg:p-12 lg:pt-14">
          <div className="text-center">
            <h3 className="font-head text-3xl font-extrabold text-[#0B1220]">
              Pack <span className="text-[#3B82F6]">30 vidéos</span> / mois
            </h3>
            <p className="mx-auto mt-3 max-w-md text-[#5B6B85]">
              30 vidéos prêtes à publier, une image de marque qui vous démarque.
            </p>
            <div className="mt-8 font-head text-5xl font-extrabold text-[#0B1220]">{OFFER.price}</div>
          </div>

          <div className="mt-10 rounded-2xl border border-[#2563EB]/20 bg-[#2563EB]/[0.06] p-7">
            <p className="mb-6 text-center text-[11px] font-bold uppercase tracking-[0.2em] text-[#5B6B85]">
              Ce qui est inclus
            </p>
            <ul className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
              {OFFER.features.map((f, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#2563EB]">
                    <Check size={12} className="text-[#0B1220]" strokeWidth={3} />
                  </span>
                  <span className="text-sm text-[#334155]">{f}</span>
                </li>
              ))}
            </ul>
          </div>

          <a
            href={ICLOSED_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="pricing-cta"
            className="btn-blue mt-8 flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-sm font-semibold text-[#0B1220]"
          >
            Je veux devenir la référence de mon marché
            <ArrowUpRight size={18} />
          </a>
          <p className="mt-4 text-center text-xs text-[#64748B]">{OFFER.note}</p>
        </div>
      </motion.div>
    </section>
  );
}
